import urlUtil from '../utils/urlUtil'

const BUSINESS_CODE = {
  ELEAVE_FERIAS: 'eLeave-ferias', // eLeave-ferias: 批准享受; eLeave-falta: 批准合理; eLeave-transfer: 轉移
  ELEAVE_TRANSFER: 'eLeave-transfer',
  ELEAVE_FALTA: 'eLeave-falta',
  ELEAVE_NO_LONG_FERIAS: 'eLeave-noLongFerias', // 未能享受長假
  TRAINING: 'training',
  BIRTH_SUBSIDY: 'birth-subsidy',
  MARRIAGE_SUBSIDY: 'marriage-subsidy',
  OFICIO: 'ofc',
  SICK_LEAVE: 'sickLeave',
  DOC_FLOW: 'docFlow',
  SUGGEST: 'suggestion',
  ESIGN: 'eSign',
  ATTEND_CHANGE: 'atdSupplementary',
  LEAVE_MARK: 'leaveMark',
  OT_PROPOSAL: 'ot-proposal',
  OT_RECORD: 'ot-record',
  OT_COMPENSATE: 'ot-compensate'
}

// const DMS_BUSINESS_CODE = [
//   BUSINESS_CODE.ELEAVE_FERIAS,
//   BUSINESS_CODE.ELEAVE_TRANSFER,
//   BUSINESS_CODE.ELEAVE_FALTA,
//   BUSINESS_CODE.TRAINING
// ]

const FORM_TEMPLATE_CODE = {
  ELEAVE: '00010', // eLeave-ferias: 批准享受; eLeave-falta: 批准合理; eLeave-transfer: 轉移
  TRAINING: '00060',
  BIRTH_SUBSIDY: '00200',
  MARRIAGE_SUBSIDY: '00201'
}

const LOCAL_STORAGE_KEY = {
  SIGN_OBJ: 'g2e-sign-obj',
  G2E_JWT_TOKEN: 'g2e-jwt-token',
  G2E_BATCH_SIGN_BUSINESS_CODE: 'g2e-batchSignBusinessCode', // for storing a business which is signing in batch or not
  G2E_SUCCESS_MESSAGE_KEY: 'g2e-successMessageKey',
  G2E_FAIL_MESSAGE_KEY: 'g2e-failMessageKey',
  G2E_REDIRECT_PATH: 'g2e-redirectPath',
  G2E_BIZ_CODE: 'g2e-biz-code',
  G2E_BATCH_DOCUMENT_IDS: 'g2e-batchDocumentIds' // The batch document ids for signing
}

const WORKFLOW_ACTION_TYPE = {
  AGREE: 1, // 同意
  APPROVE: 2, // 批准(最終審批時用)
  CANCEL: 3, // 取消
  UNAPPROVE: 4, // 不批准(最終審批時用)
  END: 5 // 完結
}

const APP_CODE_STATUS = ['', 'R', 'A', 'C', 'N', '']

const WORKFLOW_STATUS = {
  ACTIVE: 'A',
  HISTORY: 'H',
  TRANSFER: 'T'
}

const ABSENT_TYPE = {
  DEAD_FIRST_SECOND_ID: 13,
  DEAD_THIRD_ID: 14,
  PUBLIC_EXAM_ID: 26,
  EXAM_SUBJECT_ID: 24
}

const PER_SERVICES = {
  ELEAVE: 'S-eLeave',
  PAPER_LEAVE: 'S-paperLeave',
  TRAINING: 'S-training',
  SICK_LEAVE: 'S-sickLeave',
  SUBSIDY: 'S-subsidy',
  ATTENDANCE: 'S-attendance',
  E_ATTENDANCE: 'S-eAttendance',
  OVERTIME: 'S-overtime',
  SUBSTITUTE: 'S-substitute',
  EDOC_TRANSMIT: 'S-eDocTransmit',
  CONTACTS: 'S-contacts'
}

const PER_FUNCTIONS = {
  ELEAVE_ADM: 'F-eLeave-adm',
  TRAINING_ADM: 'F-training-adm',
  SICK_LEAVE_ADM: 'F-sickLeave-adm',
  SUBSIDY_ADM: 'F-subsidy-adm',
  ATTENDANCE_ADM: 'F-attendance-adm',
  EDOC_TRANSMIT: 'F-eDocTransmit',
  EDOC_TRAN_ENTITY: 'F-eDocTran-entity',
  EDOC_TRAN_SUBUNIT: 'F-eDocTran-subunit',
  EDOC_TRAN_SEARCH_SECURITY: 'F-eDocTran-searchSecurity',
  LEAVE_MARK_SUBUNIT: 'F-leaveMark-subunit',
  LEAVE_MARK_ADM: 'F-leaveMark-adm',
  CONFIDENTIAL_DOC_ADM: 'F-confidentialDoc-adm'
}

const NOT_ALLOWED_REASON = {
  NO_SERVICE: 'noService',
  NO_FUNCTION: 'noFunction'
}

const FORM_STATUS = {
  ACTIVATE: 'A',
  CANCEL: 'C',
  APPROVED: 'O',
  END: 'E',
  REJECT: 'R'
}

const DEVICE_TYPE = {
  WEB: 'W',
  APP: 'A',
  PWA: 'P'
}

const OUTBOX_ENTITY_SOURCE_TYPE = {
  APM: 1,
  ATFM: 2
}

const OUTBOX_OFICIO_TYPE = {
  OFICIO: 1,
  OFICIO_CIRCULAR: 2
}

const OUTBOX_FILE_TYPE = {
  OFICIO: 1,
  ATTACHMENT: 2,
  REFERENCE: 3,
  INTERPELLATION: 4
}

const MIME_TYPES_TO_FILE_EXTENSION = {
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx'
}

const WORKFLOW_META_KEY = {
  ISSUE_ENTITY_ID: 'issueEntityId',
  ISSUE_ENTITY_ABBR: 'issueEntityAbbr',
  ISSUE_ENTITY_CHIN_NAME: 'issueEntityChinName',
  ISSUE_ENTITY_PORT_NAME: 'issueEntityPortName',
  ISSUE_SUBUNIT_ENTITY_ID: 'issueSubunitEntityId',
  ISSUE_SUBUNIT_ENTITY_ABBR: 'issueSubunitEntityAbbr',
  ISSUE_SUBUNIT_ENTITY_CHIN_NAME: 'issueSubunitEntityChinName',
  ISSUE_SUBUNIT_ENTITY_PORT_NAME: 'issueSubunitEntityPortName',
  IS_URGENT: 'isUrgent',
  IS_DIRECT_SEND_TO_EDOCX: 'parameter1',
  APPROVER_EUID: 'approver',
  IS_ENCRYPTED_DOC: 'isEncryptedDoc',
  SECURITY_LEVEL_ID: 'securityLevelId'
}

const EMAIL_REMINDER_TYPE = {
  URGENT: 1,
  ALL: 2,
  NONE: 3
}

const TASK_LIST_JOB_TYPE = {
  MY_JOB: 1,
  GROUP_JOB: 2,
  ATTENTION_JOB: 3
}

const SEARCH_STAFF_RECORD_TYPE = {
  STAFF: 'Staff',
  GROUP: 'Group'
}

const FILTER_STATUS_ID = {
  ALL: 1,
  SIGNED: 2,
  PROCESSING: 3,
  CANCELED: 4
}

const OLD_WORKITEM_STATUS = {
  TRANSFER: 'T',
  ROLLBACK: 'B'
}

const SIGNING_JOB_STATUS = {
  ACTIVE: 'A',
  COMPLETE: 'C',
  FAIL: 'F'
}

const DOC_FLOW_STATUS = {
  NORMAL_CLOSED: 'B',
  APPROVER_CLOSED: 'A',
  CLOSED: 'C',
  PROCESSED: 'F', // Finished/Forward
  WAITING: 'W',
  REDIRECTED: 'R',
  CANCEL: 'L',
  TOEDOCX: 'E',
  TRANSFERTOEDOCX: 'T',
  MARKDELETE: 'D'
}

const DOC_FLOW_FILE_TYPE = {
  OFICIO: 'DM', // document main
  ATTACHMENT: 'DA', // document attachment
  REFERENCE: 'PA' // process attachment
}

const DOC_FLOW_ACTION_TYPE = {
  FORWARD: 'F',
  ADD: 'A',
  DELETE: 'D'
}

const DOC_FLOW_TYPE = {
  DOC_FLOW: 'D',
  SUGGESTION: 'S',
  MEDICAL_CERT: 'M'
}

const INFLOW_STATUS_CODES = {
  ACTIVE: 'A',
  VOID: 'V',
  DELETE: 'D'
}

const DOC_FLOW_CANNED_MSG_I18NS = [
  'eDocInternal.cannedMsg.opinion',
  'eDocInternal.cannedMsg.report',
  'eDocInternal.cannedMsg.suggestion',
  'eDocInternal.cannedMsg.follow',
  'eDocInternal.cannedMsg.translate',
  'eDocInternal.cannedMsg.know',
  'eDocInternal.cannedMsg.circulate',
  'eDocInternal.cannedMsg.archiveDoc',
  'eDocInternal.cannedMsg.planning'
]

const MC_NOTIFY_STATUS = {
  WAIT: 'W',
  CANCEL: 'L',
  READ: 'C',
  REDIRECTED: 'R'
}

const EDOC_SORT_PROP = {
  RECEIVE_DATE: 0,
  URGENT: 1,
  DEADLINE_DATE: 2
}

const MAPA_MODE = {
  VIEW: 0,
  PRINT: 1
}

const BW_WORKFLOW_ACT_BY = {
  PERSON: 'P',
  GROUP: 'G'
}

const BW_WORKFLOW_ACTION = {
  AGREE: 'agree',
  APPROVE: 'approve',
  TO_BIZ_DEPT: 'to_biz_dept',
  REJECT: 'reject',
  CANCEL: 'cancel',
  TRANSFER: 'transfer'
}

const BW_WORKFLOW_FLOW_TO = {
  STOP: 'stop'
}

const BW_SIGN_TYPE = {
  IDENTITY: 0,
  ESIGN: 1
}

const BW_SIGN_STATUS = {
  FAIL: 0,
  SUCCESS: 1,
  WAITING: 2,
  SIGNING: 3
}

const SECURITY_LEVEL = {
  SECRET: 2,
  CONFIDENTIAL: 3,
  TOP_CONFIDENTIAL: 4
}

const SSM_STATUS = {
  UNSIGNED: 'U',
  SIGNED: 'S',
  CANCELLED: 'C'
}

const HIDE_NOTICE_AND_NEXT_DEPARTMENTS = [338] // 貿促局

const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH
const DEVICE_TYPE_CODE = DEVICE_TYPE[process.env.VUE_APP_MODE]
const SIGN_CB_URL = urlUtil.getRootUrl() + PUBLIC_PATH + '/signCbReceiver'
const ID_SIGN_COMPLETE_CB_URL = urlUtil.getRootUrl() + PUBLIC_PATH + '/idSignAndCompleteCbReceiver'
const SIGN_BY_STAFFCODE_CB_URL = urlUtil.getRootUrl() + PUBLIC_PATH + '/signByStaffCbReceiver'
const ID_SIGN_AND_DOWNLOAD_PDF_CB_URL = urlUtil.getRootUrl() + PUBLIC_PATH + '/idSignAndDownloadPdfCbReceiver'
const BW_ESIGN_CB_URL = urlUtil.getRootUrl() + PUBLIC_PATH + '/bwEsignCbReceiver'
const ID_SIGN_IN_BATCH_CB_URL = urlUtil.getRootUrl() + PUBLIC_PATH + '/idSignBatchCbReceiver'
const LOADING_TIMEOUT = 8000 // 8 seconds
const WORKFLOW_FORM_CODE_PREFIX_NEW = '05500'
const OUTBOX_REPLY_DOC_CNT = 3
const EDOCX_I18N_PREFIX = 'TaskList.eDocX.Status.'

export { BUSINESS_CODE, FORM_TEMPLATE_CODE, PUBLIC_PATH, DEVICE_TYPE_CODE, SIGN_CB_URL, SIGN_BY_STAFFCODE_CB_URL, LOCAL_STORAGE_KEY, WORKFLOW_ACTION_TYPE, ABSENT_TYPE, WORKFLOW_STATUS, LOADING_TIMEOUT, PER_SERVICES, PER_FUNCTIONS, NOT_ALLOWED_REASON, APP_CODE_STATUS, FORM_STATUS, OUTBOX_ENTITY_SOURCE_TYPE, OUTBOX_OFICIO_TYPE, OUTBOX_FILE_TYPE, MIME_TYPES_TO_FILE_EXTENSION, WORKFLOW_META_KEY, WORKFLOW_FORM_CODE_PREFIX_NEW, OUTBOX_REPLY_DOC_CNT, EMAIL_REMINDER_TYPE, TASK_LIST_JOB_TYPE, SEARCH_STAFF_RECORD_TYPE, FILTER_STATUS_ID, OLD_WORKITEM_STATUS, EDOCX_I18N_PREFIX, SIGNING_JOB_STATUS, DOC_FLOW_STATUS, DOC_FLOW_FILE_TYPE, DOC_FLOW_ACTION_TYPE, DOC_FLOW_TYPE, DOC_FLOW_CANNED_MSG_I18NS, INFLOW_STATUS_CODES, ID_SIGN_AND_DOWNLOAD_PDF_CB_URL, ID_SIGN_COMPLETE_CB_URL, MC_NOTIFY_STATUS, EDOC_SORT_PROP, MAPA_MODE, ID_SIGN_IN_BATCH_CB_URL, BW_WORKFLOW_ACT_BY, BW_WORKFLOW_ACTION, BW_WORKFLOW_FLOW_TO, BW_SIGN_TYPE, BW_ESIGN_CB_URL, BW_SIGN_STATUS, SECURITY_LEVEL, SSM_STATUS, HIDE_NOTICE_AND_NEXT_DEPARTMENTS }
export default { BUSINESS_CODE, FORM_TEMPLATE_CODE, PUBLIC_PATH, DEVICE_TYPE_CODE, SIGN_CB_URL, SIGN_BY_STAFFCODE_CB_URL, LOCAL_STORAGE_KEY, WORKFLOW_ACTION_TYPE, ABSENT_TYPE, WORKFLOW_STATUS, LOADING_TIMEOUT, PER_SERVICES, PER_FUNCTIONS, NOT_ALLOWED_REASON, APP_CODE_STATUS, FORM_STATUS, OUTBOX_ENTITY_SOURCE_TYPE, OUTBOX_OFICIO_TYPE, OUTBOX_FILE_TYPE, MIME_TYPES_TO_FILE_EXTENSION, WORKFLOW_META_KEY, WORKFLOW_FORM_CODE_PREFIX_NEW, OUTBOX_REPLY_DOC_CNT, EMAIL_REMINDER_TYPE, TASK_LIST_JOB_TYPE, SEARCH_STAFF_RECORD_TYPE, FILTER_STATUS_ID, OLD_WORKITEM_STATUS, EDOCX_I18N_PREFIX, SIGNING_JOB_STATUS, DOC_FLOW_STATUS, DOC_FLOW_FILE_TYPE, DOC_FLOW_ACTION_TYPE, DOC_FLOW_TYPE, DOC_FLOW_CANNED_MSG_I18NS, INFLOW_STATUS_CODES, ID_SIGN_AND_DOWNLOAD_PDF_CB_URL, ID_SIGN_COMPLETE_CB_URL, MC_NOTIFY_STATUS, EDOC_SORT_PROP, MAPA_MODE, ID_SIGN_IN_BATCH_CB_URL, BW_WORKFLOW_ACT_BY, BW_WORKFLOW_ACTION, BW_WORKFLOW_FLOW_TO, BW_SIGN_TYPE, BW_ESIGN_CB_URL, BW_SIGN_STATUS, SECURITY_LEVEL, SSM_STATUS, HIDE_NOTICE_AND_NEXT_DEPARTMENTS }
